import { motion } from "framer-motion";

const AnimatedScrollHeader = ({ children, duration = 0.8, watch }) => {
  // Variants clairs
  const variants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration } },
  };

  // On donne la key = watch pour forcer le remount quand watch change
  return (
    <motion.div
      key={String(watch ?? "static")}
      initial="hidden"
      animate="visible"
      variants={variants}
      style={{ willChange: "transform, opacity" }} // aide perf / rendu
    >
      {children}
    </motion.div>
  );
};

export default AnimatedScrollHeader;
